import { Layers, ShieldCheck, Sprout, HeartHandshake } from "lucide-react";
import { Reveal, SectionTag, SectionHeading } from "@/components/landing/Reveal";
import { useLang } from "@/lib/i18n";

const BENEFITS = [
  { icon: Layers, titleKey: "why.b1t", descKey: "why.b1d" },
  { icon: ShieldCheck, titleKey: "why.b2t", descKey: "why.b2d" },
  { icon: Sprout, titleKey: "why.b3t", descKey: "why.b3d" },
  { icon: HeartHandshake, titleKey: "why.b4t", descKey: "why.b4d" },
];

export default function Why() {
  const { t } = useLang();
  return (
    <section data-testid="why-section" className="bg-bone py-24 text-ink sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionTag number="03" label={t("why.tag")} dark={false} />
        <SectionHeading dark={false}>{t("why.heading")}</SectionHeading>
        <div className="mt-16 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map((b, i) => (
            <Reveal key={b.titleKey} delay={0.08 + i * 0.1}>
              <div data-testid={`why-card-${i}`} className="group">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-forest/10 text-forest transition-colors duration-500 group-hover:bg-forest group-hover:text-mint">
                  <b.icon className="h-5 w-5" />
                </div>
                <h3 className="mt-6 font-display text-lg font-bold tracking-tight">{t(b.titleKey)}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60">{t(b.descKey)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
